import { ofType } from "redux-observable";
import { mapTo } from "rxjs/operators";
import { actionGameTrackingUpdateShop } from "../../actionGameTracking";
import { TypeActionGameTrackingShopOpenSource } from "../actionGameTrackingShop";
import { IdGameTrackingShopState } from "../IdGameTrackingShopState";
export var epicGameTrackingShopProviderNavigate = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionGameTrackingShopOpenSource.ProviderNavigate), mapTo(actionGameTrackingUpdateShop(IdGameTrackingShopState.PROVIDER_NAVIGATE)));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/shop/epics/epicGameTrackingShopProviderNavigate.ts
// module id = 1882
// module chunks = 3